export function initAnalytics() {
  // Logo flip
  document.querySelector('#flip').addEventListener('change', function () {
    if (this.checked) {
      ga('send', 'event', 'surprises', 'click', 'peekaboo!');
    }
  });
}